export const isHiddenFor = (pathname, hiddenPaths = []) => {
  return hiddenPaths.some((path) => pathname.includes(path));
};
